import { LOCALES } from './i18n/config';

/** Public origin for canonical/hreflang/sitemap URLs. Set VITE_SITE_URL at build time in prod. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'http://localhost:8080').replace(
  /\/$/,
  '',
);

/** Public, indexable pages (without the locale prefix). Each is prerendered for every locale. */
export const PUBLIC_PAGES = ['/', '/models', '/docs'] as const;

export function prerenderPaths(): string[] {
  return LOCALES.flatMap((locale) =>
    PUBLIC_PAGES.map((page) => (page === '/' ? `/${locale}/` : `/${locale}${page}`)),
  );
}
